globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.FixedBloc = (function()
{
  function FixedBloc($element, $container) {
    if($element.length === 1) {
      this.$element = $element;
    }
    if($container !== undefined && $container.length === 1) {
      this.$container = $container;
    } else {
      this.$container = $("body");
    }
  }

  FixedBloc.prototype =
  {
    backToStatic : function() {
      this.$element.css({width: "100%", position: "static", top: "auto"});
    },
    init : function() {
      if(this.$element) {
        var windowWidth, windowHeight,
            elementTop, elementWidth, elementHeight,
            containerTop, containerHeight,
            bodyScrollTop;
        var $window = $(window);
        var bodyContainerOffsetTop = $('#body-container').offset().top;
        var self    = this;

        $window.resize(function()
        {
          self.backToStatic();
          windowWidth         = $window.width();
          windowHeight        = $window.height();
          elementTop          = self.$element.offset().top;
          elementWidth        = self.$element.outerWidth();
          elementHeight       = self.$element.outerHeight();
          containerTop        = self.$container.offset().top;
          containerHeight     = self.$container.outerHeight();
          $window.scroll();
        });

        $window.scroll(function()
        {
          if(windowWidth > 768 && containerHeight > elementHeight)
          {
            bodyScrollTop   = $window.scrollTop();
            if(bodyScrollTop + bodyContainerOffsetTop > elementTop) {
              if(bodyScrollTop + elementHeight > containerTop + containerHeight) {
                self.$element.css({width: elementWidth, position: "fixed", top: "inherit", bottom: (bodyScrollTop + windowHeight - (containerTop + containerHeight))});
              } else {
                self.$element.css({width: elementWidth, position: "fixed", top: bodyContainerOffsetTop, bottom: "inherit"});
              }
            } else {
              self.backToStatic();
            }
          }
        });
        $window.resize();
        return self;
      }
    }
  }
  return FixedBloc;
})();
